/* eslint-disable max-lines*/
/* eslint-disable indent */
// Libraries

// Layouts

// Helper
import { getRmName } from '../../utils/helperMethods';

import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';

// Actions
import {
    updateImageRequest,
    updateImageError,
    fetchProfileDetailsRequest,
    fetchProfileDetailsError,
    fetchProfileJSONRequest,
    fetchProfileJSONError,
    deleteImageRequest,
    deleteImageError,
    resetImageSuccess,
    createStaticQrRequest,
    resetStaticQrData,
} from '../../containers/Profile/redux/profile.actions';

// Components
import {
    Modal,
    FormElems,
    Alert,
    ConditionalComponent,
} from '../../components';

// Assets
import LogoDefault from '../../static/images/Cards/defaultLogo.png';
import closeImgIcon from '../../static/images/close.svg';
import Cross from '../../static/images/remove.png';
import PictureIcon from '../../static/images/picture.png';
import Rupay from '../../static/images/Cards/rupay.png';
import MasterCard from '../../static/images/Cards/mastercard.png';
import Visa from '../../static/images/Cards/visa.png';
import Amex from '../../static/images/Cards/amex.png';
import { toast } from 'react-toastify';
import { isEmpty, size } from 'lodash';
import { useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { useState, useCallback, useEffect } from 'react';

// Styles
import './profile.scss';
import { ENTITY_TYPE } from 'utils/constants/commonValues';

function ImageDropZone(props) {
    const {
        onFileChange,
        selectedFile,
        removeFile,
        currentImg,
        inputError,
    } = props;
    const [imgSrc, setImgSrc] = useState('');

    const onDrop = useCallback(
        acceptedFiles => {
            // Do something with the files
            onFileChange(null, acceptedFiles, true);
        },
        [onFileChange]
    );
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    useEffect(() => {
        if (selectedFile && selectedFile.length && !inputError) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile[0]);
            reader.onloadend = event => {
                setImgSrc([reader.result]);
            };
        } else {
            setImgSrc([]);
        }
    }, [inputError, selectedFile]);

    const dragMsg = isDragActive
        ? 'Drop the files here ...'
        : 'Drag & drop Logo here';

    return (
        <div {...getRootProps()}>
            {currentImg ? (
                <div className="logo-preview">
                    <img src={currentImg} alt="Uploaded Logo" />
                </div>
            ) : (
                <>
                    <input {...getInputProps()} />
                    <div className="logo-preview">
                        {!isEmpty(imgSrc) && !inputError ? (
                            <img src={imgSrc} alt="Uploaded Logo" />
                        ) : (
                            <div className="dragDrop-icon">
                                <img src={PictureIcon} alt="Upload" />
                            </div>
                        )}
                    </div>
                </>
            )}
            {currentImg ? (
                <p className="removeLink" onClick={removeFile}>
                    Remove Logo{' '}
                </p>
            ) : (
                <p>{dragMsg}</p>
            )}
        </div>
    );
}

const checkValidation = file => {
    if (isEmpty(file)) {
        return null;
    }
    let error = null;

    if (file && file.length && file[0].size > 1000000) {
        error = 'File size should be less than 1MB';
    }

    if (
        (file && file.length && file[0].type === 'image/jpeg') ||
        (file && file.length && file[0].type === 'image/png')
    ) {
        error = null;
    } else {
        error = 'Inavild file format, only png and jpeg type allowed';
    }
    return error;
};

const ProfileEdit = ({
    data,
    actions,
    getProfileData,
    deleteImageData,
    updateImage,
    resetImage,
}) => {
    const [showFilter, setShowFilter] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedImg, setSelectedImg] = useState(data.checkoutLogoUrl);
    const [inputError, setInputError] = useState('');
   
    useEffect(() => {
        setSelectedImg(data.checkoutLogoUrl);
    }, [data.checkoutLogoUrl]);

    const handleOpenActionPopup = () => {
        setShowFilter(true);
    };

    const handleCloseOpenActionPopup = () => {
        setShowFilter(false);
        setSelectedFile([]);
    };

    const handleUpdate = () => {
        const formData = new FormData();
        formData.append('file', selectedFile[0]);
        actions.updateImageRequest(formData);
    };

    const handleBrowse = (value, event, isDirectFile) => {
        setInputError(null);
        if (isDirectFile && event && event.length) {
            setSelectedFile(event);
        } else if (event.target && event.target.files) {
            event.preventDefault();
            const files = event.target.files;
            setSelectedFile(files);
        }
    };

    useEffect(() => {
        const inputValidate = checkValidation(selectedFile);
        setInputError(inputValidate);
    }, [selectedFile]);

    useEffect(() => {
        if (updateImage.isSuccess) {
            toast.info(SUCCESS_MESSAGES.IMAGE('Profile Image'));
            getProfileData();
            setShowFilter(false);
        }
        return () => {
            actions.updateImageError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateImage.isSuccess]);

    useEffect(() => {
        if (deleteImageData.isSuccess) {
            toast.info(SUCCESS_MESSAGES.REMOVED_DATA('Profile Image'));
            setSelectedFile([]);
            getProfileData();
        }
        return () => {
            actions.deleteImageError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteImageData.isSuccess]);

    useEffect(() => {
        if (resetImage) {
            setSelectedFile([]);
        }
        return () => {
            actions.resetImageSuccess();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetImage]);

    const onRemoveFile = () => {
        setInputError(null);
        actions.deleteImageRequest();
    };

    return (
        <div className="profile-edit">
            <span className="edit-link" onClick={handleOpenActionPopup}>
                Edit logo
            </span>
            <Modal
                modalIsOpen={showFilter}
                closeModal={handleCloseOpenActionPopup}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                customWrapperClass="profile-modal-edit"
            >
                <div className="upload-logo-wrap">
                    {inputError && (
                        <Alert customClass="error-msg">{inputError}</Alert>
                    )}
                    <span
                        className="cross-btn"
                        onClick={handleCloseOpenActionPopup}
                    >
                        <img src={Cross} alt="Close" />
                    </span>
                    <div className="image-container">
                        <ImageDropZone
                            onFileChange={handleBrowse}
                            selectedFile={selectedFile}
                            removeFile={onRemoveFile}
                            currentImg={selectedImg}
                            inputError={inputError}
                        />
                    </div>
                    <div className="action-buttons">
                        <label
                            htmlFor="file"
                            className={`secondary-button ${
                                selectedImg ? 'disable' : ''
                            }`}
                        >
                            BROWSE &amp; UPLOAD
                        </label>
                        <form encType="multipart/form-data" action="">
                            <FormElems.Input
                                name="file"
                                type="file"
                                id="file"
                                wrapperClass="fileInput"
                                defaultValue="fileName"
                                input="false"
                                handleChange={handleBrowse}
                            />
                        </form>
                        <FormElems.Button
                            buttonType="primary"
                            text="UPDATE"
                            type="button"
                            customClass="secondary-update"
                            handleClick={handleUpdate}
                            isDisable={
                                !size(selectedFile) || selectedImg || inputError
                            }
                        />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

const getBankName = (bankList, bankCode) => {
    if (bankList && bankList.BANK_CODE && bankCode) {
        const bankData = bankList.BANK_CODE[bankCode];
        return bankData && bankData.codeNameUI;
    }
    return null;
};

const Profile = props => {
    const {
        actions,
        auth,
        loader: { showLoader },
        profileData,
        staticData,
        payValues,
        underlyingMerchant
    } = props;
    const { relationshipManagers } = staticData;
    
     const [isTerminalView, setTerminalView] = useState(false)
        useEffect(()=>{
            
            if(underlyingMerchant?.[0]?.entityType && underlyingMerchant?.[0]?.entityType == ENTITY_TYPE.TERMINAL){
                setTerminalView(true)
            }
        },[underlyingMerchant?.[0]?.entityCode])
    const {
        data,
        updateImage,
        deleteImage,
        resetImage,
        sdkData,
        createStaticQrData,
    } = profileData;

    const isStaticQREnabled = profileData?.data?.staticQREnabled;
    const { staticQrString } = createStaticQrData;

    const { userDetails } = auth;

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const generateStaticQR = () => {
        actions.createStaticQrRequest({
            merchantId: userDetails.associatedEntityId,
        });
    };

    const onStaticQrPopupClose = () => {
        setIsPopupOpen(false);
        actions.resetStaticQrData();
    };

    useEffect(() => {
        if (createStaticQrData.isSuccess) {
            setIsPopupOpen(true);
        }
    }, [createStaticQrData.isSuccess]);

    const getProfileData = () => {
        if (userDetails.associatedEntityId) {
            const request = {
                merchantCode: userDetails.associatedEntityId || '',
            };
            actions.fetchProfileDetailsRequest(request);
        }
    };

    const handleDownloadSdk = fileName => {
        if (fileName) {
            const fileUrl = `/assets/sdks/${fileName}`;
            const link = document.createElement('a');
            link.href = fileUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    useEffect(() => {
        // actions.fetchProfileJSONRequest();
        return () => {
            actions.fetchProfileJSONError();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getProfileData();
        return () => {
            actions.fetchProfileDetailsError({ error: '' });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions, userDetails.associatedEntityId]);

    const getImageUrl = item => {
        switch (item.paymentModeInfo) {
            case 'RPAY':
                return Rupay;
            case 'VI':
                return Visa;
            case 'MC':
                return MasterCard;
            case 'AMEX':
                return Amex;
            default:
                return '';
        }
    };

    return (
        <div className="profile-wrapper">
            <div className="profile-header clearfix">
                <h3 className="page-tile">Merchant Profile </h3>
            </div>
            <div className="profile-view">
                <div className="profile-details">
                    <div className="logo">
                        {data.checkoutLogoUrl ? (
                            <img
                                src={data.checkoutLogoUrl}
                                alt="Merchant Logo"
                            />
                        ) : (
                            <img src={LogoDefault} alt="Default Logo" />
                        )}
                        <ProfileEdit
                            actions={actions}
                            data={data}
                            getProfileData={getProfileData}
                            deleteImageData={deleteImage}
                            updateImage={updateImage}
                            resetImage={resetImage}
                        />
                    </div>
                    <ul>
                        <li>
                            <label>{isTerminalView ? "Terminal Name" :"Merchant Name"}</label>
                            <span>{data.name}</span>
                        </li>
                        <li>
                            <label>{isTerminalView ? "Terminal ID" : "Merchant ID"}</label>
                            <span>{data.entityCode}</span>
                        </li>
                        <li>
                            <label>Registered Email ID</label>
                            <span>{data.email}</span>
                        </li>
                        <li>
                            <label>Relationship Manager</label>
                            <span>
                                {getRmName(
                                    data.relationshipManagerId,
                                    relationshipManagers
                                )}
                            </span>
                        </li>
                        <li>
                            <label>RM Email ID</label>
                            <span>{data.relationshipManagerId}</span>
                        </li>
                    </ul>
                </div>
                <div className="details-header clearfix">
                    <h3 className="page-tile">Enable Payment Mode</h3>
                </div>
                <div className="merchant-pay-details">
                    <div className="card-details">
                        <h4>Credit Card</h4>
                        {data &&
                        data.paymentModeDetails &&
                        data.paymentModeDetails.creditCard.length ? (
                            <>
                                <ul className="card-list">
                                    {data.paymentModeDetails.creditCard.map(
                                        item => (
                                            <li>
                                                <img
                                                    src={getImageUrl(item)}
                                                    alt="Credit Card"
                                                />
                                            </li>
                                        )
                                    )}
                                </ul>
                            </>
                        ) : (
                            <p className="not-applicable">N/A</p>
                        )}
                        <h4>Debit Card</h4>
                        {data &&
                        data.paymentModeDetails &&
                        data.paymentModeDetails.debitCard.length ? (
                            <>
                                <ul className="card-list">
                                    {data.paymentModeDetails.debitCard.map(
                                        item => (
                                            <li>
                                                <img
                                                    src={getImageUrl(item)}
                                                    alt="Credit Card"
                                                />
                                            </li>
                                        )
                                    )}
                                </ul>
                            </>
                        ) : (
                            <p className="not-applicable">N/A</p>
                        )}
                    </div>
                    <div className="bank-details">
                        <h4>Net Banking</h4>
                        {data &&
                        data.paymentModeDetails &&
                        data.paymentModeDetails.netBanking.length ? (
                            <ul className="bank-list">
                                {data.paymentModeDetails.netBanking.map(
                                    item => (
                                        <li>
                                            {getBankName(
                                                payValues,
                                                item.paymentModeInfo
                                            )}
                                        </li>
                                    )
                                )}
                            </ul>
                        ) : (
                            <p className="not-applicable">N/A</p>
                        )}
                    </div>
                </div>

                {sdkData && sdkData.sdkList && sdkData.sdkList.length ? (
                    <>
                        <div className="details-header clearfix">
                            <h3 className="page-tile">Download SDK</h3>
                        </div>
                        <div className="sdk-download">
                            <ul className="sdk-list">
                                {sdkData.sdkList.map(item => (
                                    <li
                                        onClick={() =>
                                            handleDownloadSdk(item.filePath)
                                        }
                                        key={item.name}
                                    >
                                        <span className="sdk-title">
                                            {item.name}
                                        </span>
                                        <div className="sdk-details">
                                            <img
                                                src={`/assets/sdks/${item.imgPath}`}
                                                alt={item.name}
                                            />
                                        </div>
                                        <div className="sdk-info">
                                            <span className="sdk-subText version">
                                                Version: {item.version}
                                            </span>
                                            <span className="sdk-subText lastUpdate">
                                                Last Update: {item.lastUpdated}
                                            </span>
                                        </div>
                                        <div className="sdk-link">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                />
                                            </svg>
                                            <span> Download</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </>
                ) : null}

                <ConditionalComponent isVisible={isStaticQREnabled}>
                    <div className="show-profile-button-container">
                        <FormElems.Button
                            customClass="show-profile-button"
                            buttonType="secondary"
                            id={'show-profile-qr'}
                            text={`Generate Static QR`}
                            type="button"
                            handleClick={generateStaticQR}
                        />
                    </div>
                    <Modal
                        modalIsOpen={isPopupOpen}
                        closeModal={onStaticQrPopupClose}
                        customWrapperClass={`content-modal`}
                    >
                        <div className="modal-header">
                            <h2 className="modal-heading">Your Static QR</h2>
                            <img
                                src={closeImgIcon}
                                alt="Close"
                                onClick={onStaticQrPopupClose}
                            />
                        </div>
                        <div className="modal-body">
                            <img
                                src={`data:image/png;base64, ${staticQrString}`}
                                alt="base-64-image"
                            />
                        </div>
                    </Modal>
                </ConditionalComponent>
            </div>
        </div>
    );
};

const mapStateToProps = ({ auth, loader, profileData, staticData }) => ({
    auth,
    loader,
    profileData,
    staticData: staticData && staticData.staticInfo,
    underlyingMerchant : staticData && staticData.underlyingMerchant,
    payValues: staticData && staticData.payValues,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            updateImageRequest,
            fetchProfileDetailsRequest,
            fetchProfileDetailsError,
            fetchProfileJSONRequest,
            fetchProfileJSONError,
            updateImageError,
            deleteImageError,
            deleteImageRequest,
            resetImageSuccess,
            createStaticQrRequest,
            resetStaticQrData,
        },
        dispatch
    ),
});

Profile.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    loader: PropTypes.bool,
    profileData: PropTypes.object,
    staticData: PropTypes.object,
    payValues: PropTypes.object,
};

ProfileEdit.propTypes = {
    data: PropTypes.object,
    actions: PropTypes.func,
    getProfileData: PropTypes.func,
    deleteImageData: PropTypes.object,
    updateImage: PropTypes.object,
    resetImage: PropTypes.any,
};

ImageDropZone.propTypes = {
    onFileChange: PropTypes.func,
    selectedFile: PropTypes.array,
    removeFile: PropTypes.any,
    currentImg: PropTypes.any,
    inputError: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
